import moment from 'moment'
import Vue from 'vue'
import Common from '../Common/Constants'
import AlertModal from '../Common/AlertModal'
import DeleteConfirmDialog from '../Common/DeleteConfirmDialog'
import Loader from '../Common/Loader.vue'
import axios from "axios/index";
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
    name: "KnowledgeBase",
    components: {AlertModal, Treeselect, Loader, DeleteConfirmDialog},
    data() {
        return {
            constant: Common,
            header: {},
            valid: false,
            loader: false,
            successToast: {
                theme: "primary",
                position: "top-right",
                duration: 3000,
                className: 'success-toast'
            },
            errorToast: {
                theme: "primary",
                position: "top-right",
                duration: 3000,
                className: 'error-toast'
            },
            addKBDialog: false,
            kb: {
                type: '',
                title: '',
                description: '',
                attachment: [],
                categories: [],
                file: '',
                utubeURL: null,
                folder: null,
            },
            fileName: '',
            // fileName: [],
            file: '',
            categoriesArr: [],
            fileResponse: {},
            utubeFlag: false,
            mediaFlag: false,
            urlFlag: false,
            FAQFlag: false,
            textFlag: false,
            saveBtnFlag: false,
            uploadBtnFlag: false,
            alertDialog: false,
            msg: 'Hello',
            faq: '',
            KBData: [],
            fieldRules: [
                (v) => {
                    if (!v || v.length < 1)
                        return 'This field is required';
                    else return true;
                }
            ],
            nameRules: [
                v => !!v || 'This field is required',
                (v) => {
                    if (!v || v.length <= 3)
                        return 'Must be greater than 3 characters';
                    else return true;
                },
            ],

            folderData: [],
            value: null,
            normalizer(node) {
                return {
                    id: node.id,
                    label: node.name,
                    children: node.childrenArr,
                }
            },
            delKBData: {},
            editData: {},
            delDialog: false,
            addEditFlag: false,
            searchFlag: false,
            search: '',
            tempKBData: [],
            preparedFolderArr: [],
        }
    },
    filters: {
        kbCategoryFilter(val) {
            return Vue.prototype.$kbCategories[val]
        }
    },
    created() {
        let self = this;
        self.getKnowledgeBase();
    },
    computed: {
        selectAllCategories() {
            return this.kb.categories.length === this.categoriesArr.length
        },
        selectSomeCategories() {
            return this.kb.categories.length > 0 && !this.likesAllFruit
        },
        icon() {
            if (this.selectAllCategories) return 'check_box';
            if (this.selectSomeCategories) return 'indeterminate_check_box';
            return 'check_box_outline_blank';
        },
        filterKB() {
            let self = this;
            if (self.KBData.length != 0) {
                let result = self.KBData.filter(function (kb) {
                    return (kb.title.toLowerCase().indexOf(self.search.toLowerCase()) >= 0)
                });
                if (result.length == 0) {
                    return this.searchFlag = true
                }
                else {
                    this.searchFlag = false;
                    return result;
                }
            } else {
                this.searchFlag = true
            }
        },
    },
    methods: {
        toggle() {
            this.$nextTick(() => {
                if (this.selectAllCategories) {
                    this.kb.categories = [];
                } else {
                    this.kb.categories = this.categoriesArr.slice()
                }
            })
        },
        getKnowledgeBase() {
            let self = this;
            self.loader = true;
            self.KBData = [];
            self.msg = '';
            axios.get(self.constant.apiUrl + 'getKnowledgeBase')
                .then(response => {
                    if (response.data.flag) {
                        // self.KBData.push(response.data.data[1]);
                        // response.data.data.forEach(function (val) {
                        //     val.folderId="4cfd3c8d018119eef8c8aef6062013cc"
                        // });
                        self.KBData = response.data.data;
                        console.log("KBData", self.KBData)
                        self.tempKBData = JSON.parse(JSON.stringify(self.KBData));
                        self.getCategories();
                        self.getFolder();
                    } else {
                        self.alertDialog = true;
                        self.msg = response.data.message;
                    }
                }).catch((handle) => {
                self.$toasted.show('Something went wrong', self.errorToast);
            });
            // self.getFolder();
        },
        getFolder() {
            let self = this;
            self.folderData = [];
            self.msg = '';
            let tempFolderArr = []
            let obj = {}
            axios.get(self.constant.apiUrl + 'getKnowledgeBaseCollectionFolderHierarchy')
                .then(response => {
                    if (response.data.flag) {
                        self.folderData = response.data.data;
                        console.log("self.folderData", self.folderData);
                        self.prepareFolderArray();
                        // self.getCategories();
                    } else {
                        self.alertDialog = true;
                        self.msg = response.data.message;
                    }
                }).catch((handle) => {
                self.$toasted.show('Something went wrong', self.errorToast);
            });
        },
        getCategories() {
            let self = this;
            self.categoriesArr = [];
            self.msg = '';
            axios.get(self.constant.apiUrl + 'getKnowledgeBaseCategories')
                .then(response => {
                    if (response.data.flag) {
                        let obj;
                        self.categoriesArr = response.data.data;
                        self.categoriesArr.forEach(function (val) {
                            self.categoriesArr[val.id] = val.name
                        });
                        Vue.prototype.$kbCategories = self.categoriesArr
                    } else {
                        self.alertDialog = true;
                        self.msg = response.data.message;
                    }
                    // self.loader = false
                }).catch((handle) => {
                // self.loader = false;
                self.$toasted.show('Something went wrong', self.errorToast);
            })


        },
        prepareFolderArray() {
            let self = this;
            let tempArr = [];

            function findFolder(arr, folderId) {
                let result = {};
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].id == folderId) {
                        tempArr.push(arr[i].name)
                        console.log("if folder", arr[i])
                        result = arr[i]
                    } else if (arr[i].childrenArr) {
                        console.log("else if folder", arr[i])
                        tempArr.push(arr[i].name)
                        findFolder(arr[i].childrenArr, folderId);
                    }
                }
                return result
            }

            let a = {};
            for (var i = 0; i < self.tempKBData.length; i++) {
                tempArr = []
                let arr1 = self.tempKBData

                for (var j = 0; j < self.folderData.length; j++) {
                    tempArr = [];
                    let b = self.folderData
                    if (b[j].id == arr1[i].folderId) {
                        tempArr.push(b[j].name)
                        arr1[i].folder1 = {
                            id: b[j].id,
                            name: b[j].name,
                        };
                        a = arr1[i];
                    } else if (b[j].childrenArr) {
                        tempArr.push(b[j].name)
                        a = findFolder(b[j].childrenArr, arr1[i].folderId);
                        console.log("a", a)

                        arr1[i].folder1 = {
                            id: a.id,
                            name: a.name,
                        }

                    } else {
                        arr1[i].folder1 = {
                            id: '',
                            name: '',
                        }
                    }
                    if (a.id) {
                        arr1[i].preparedFolderArr = tempArr;
                        break;
                    }
                }
            }
            self.preparedFolderArr = tempArr;
            console.log("all*********", self.tempKBData)
            self.KBData = self.tempKBData
            self.loader = false;
        },
        openKBDialog() {
            let self = this;
            let ele = document.getElementsByClassName("fileId");
            ele.value = '';
            self.kb.type = '';
            self.$refs.KBForm.reset();
            self.addEditFlag = false;
            self.addKBDialog = true;
        },
        showFieldType(type) {
            let self = this;
            self.uploadBtnFlag = false;
            self.fileName = '';
            self.kb = {
                title: '',
                description: '',
                attachment: [],
                categories: [],
                file: '',
                folder: null,
                type: type
            };
            self.$refs.form.reset();
            let faqId = '';
            let videoId = '';
            if (type === 5) {
                self.categoriesArr.forEach(function (val) {
                    if (val.name === self.constant.kbType_const[5]) {
                        val.disabled = true;
                        faqId = val.id;
                    } else {
                        delete val.disabled;
                    }
                });
            }
            else if (type === 21) {
                self.categoriesArr.forEach(function (val) {
                    if (val.name === 'Videos') {
                        val.disabled = true;
                        videoId = val.id;
                    } else {
                        delete val.disabled;
                    }
                });
            }
            else {
                self.categoriesArr.forEach(function (val) {
                    delete val.disabled;
                });
            }
            /* else if (type === 2) {
             self.categoriesArr.forEach(function (val) {
                 if (val.name === 'Videos') {
                     val.disabled = true;
                     videoId = val.id;
                 } else {
                     delete val.disabled;
                 }
             });
         }*/
            if (type == 1 || type == 3 || type == 4 || type == 2) {
                // if (type == 2)
                //     self.kb.categories = [videoId];
                self.mediaFlag = true;
                self.urlFlag = false;
                self.FAQFlag = false;
                self.textFlag = false;
                self.utubeFlag = false;
            } else if (type == 7) {
                self.urlFlag = true;
                self.FAQFlag = false;
                self.textFlag = true;
                self.mediaFlag = false;
                self.utubeFlag = false;
            } else if (type == 5) {
                self.kb.categories = [faqId];
                self.FAQFlag = true;
                self.urlFlag = false;
                self.textFlag = false;
                self.mediaFlag = false;
                self.utubeFlag = false;
            } else if (type == 6) {
                self.textFlag = true;
                self.urlFlag = false;
                self.FAQFlag = false;
                self.mediaFlag = false;
                self.utubeFlag = false;
            } else if (type == 21) {
                self.kb.categories = [videoId];
                self.textFlag = false;
                self.urlFlag = false;
                self.FAQFlag = false;
                self.mediaFlag = false;
                self.utubeFlag = true;
            }
        },
        validateURL(url) {
            var url = $('#youTubeUrl').val();
            if (url != undefined || url != '') {
                var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
                var match = url.match(regExp);
                if (match && match[2].length == 11) {
                    console.log(" Match")
                    this.addKB();
                }
                else {
                    console.log("No Match")
                }
            }
        },
        addKB() {
            let self = this;
            let request = {
                "resource_category_ids": self.kb.categories,
                "message": self.utubeFlag ? {attachment: self.kb.utubeURL} : self.fileResponse,
                "title": self.kb.title,
                "type": self.kb.type,
                "fileName": self.file.name,
                "description": self.kb.description,
                "folderId": self.kb.folder,
            };
            self.msg = '';
            if (self.valid) {
                axios.post(self.constant.apiUrl + 'addKnowledgeBase', request)
                    .then(res => {
                        if (res.data.flag) {
                            self.$toasted.show('Knowledge Base added Successfully', self.successToast);
                            self.getKnowledgeBase();
                            self.cancelKBDialog();
                        } else {
                            self.alertDialog = true;
                            self.msg = res.data.message;
                        }
                    })
                    .catch((handle) => {
                        self.alertDialog = true;
                        self.msg = "Please fill all details";
                    })
            } else {
                self.alertDialog = true;
                self.msg = "Please fill valid details";
            }
        },
        cancelKBDialog() {
            let self = this;
            let ele = document.getElementsByClassName("fileId");
            ele.value = '';
            self.kb = {};
            self.$refs.KBForm.reset();
            self.uploadBtnFlag = false;
            self.addKBDialog = false;
            self.mediaFlag = false;
            self.urlFlag = false;
            self.FAQFlag = false;
            self.textFlag = false;
            self.utubeFlag = false;
        },
        editKBDialog(data) {
            let self = this;
            self.addEditFlag = true;
            self.fileResponse = {};
            let KBType = '';
            let KBDescription = '';
            let KBUTubeURL = '';
            let KBFile = '';
            if (data.message.attachments) {
                KBType = data.message.attachments[0].type;
                KBFile = data.message.attachments[0].name;
                KBDescription = data.message.text;
                KBUTubeURL = data.message.attachments[0].url;
            } else {
                KBType = data.type == 10 ? 5 : data.type == 12 ? 7 : 6;
                KBDescription = data.message;


            }
            self.showFieldType(KBType)
            self.kb = {
                type: KBType,
                title: data.title,
                description: KBDescription,
                attachment: [],
                categories: data.resource_category_ids,
                file: '',
                utubeURL: KBUTubeURL,
                folder: data.folderId,
            };
            self.fileName = KBFile;
            self.editData = data;
            self.addKBDialog = true;

        },
        updateKB() {
            let self = this;
            let request = {
                "messageObject": {
                    "attachmentId": self.fileResponse.id ? self.fileResponse.id : self.editData.attachmentId,
                    "groupId": self.editData.groupId,
                    "folderId": self.kb.folder,
                    "message": self.editData.message.attachments ? {
                        "attachments": [
                            {
                                "name": self.fileResponse.id ? self.file.name : self.editData.message.attachments[0].name,
                                "id": self.fileResponse.id ? self.fileResponse.id : self.editData.message.attachments[0].id,
                                "length": self.fileResponse.id ? self.fileResponse.size : self.editData.message.attachments[0].length,
                                "url": self.fileResponse.id ? self.fileResponse.attachment : self.editData.message.attachments[0].url,
                                "minVersion": self.editData.message.attachments[0].minVersion,
                                "progress": self.editData.message.attachments[0].progress,
                                "star": self.editData.message.attachments[0].star,
                                "type": self.kb.type,
                                "version": self.editData.message.attachments[0].version,
                            }
                        ],
                        "following": self.editData.message.following,
                        "isLiked": self.editData.message.isLiked,
                        "likeCount": self.editData.message.likeCount,
                        "messageCount": self.editData.message.messageCount,
                        "text": self.kb.description,
                        "unreadCount": self.editData.message.unreadCount
                    } : self.kb.description,
                    "messageId": self.editData.messageId,
                    "title": self.kb.title,
                    "type": self.editData.type,
                    "id": self.editData.id,
                    "createdBy": self.editData.createdBy,
                    "resource_category_ids": self.kb.categories,
                    "likesCount": self.editData.likesCount,
                    "isLikedByUser": self.editData.isLikedByUser,
                }
            };
            if (self.utubeFlag) {
                self.messageObject.message.attachments[0].url = self.kb.utubeURL;
                delete request.messageObject.attachmentId;
                delete request.messageObject.message.attachments[0].name;
                delete request.messageObject.message.attachments[0].id;
                delete request.messageObject.message.attachments[0].length;
            }
            self.msg = '';
            if (self.valid) {
                axios.put(self.constant.apiUrl + 'updateKnowledgeBase/' + self.editData.id, request)
                    .then(res => {
                        if (res.data.flag) {
                            self.getKnowledgeBase()
                            /* const index = self.KBData.indexOf(self.editData);
                             if (index != -1)
                                 self.KBData.splice(index, 1);*/
                            self.$forceUpdate();
                            self.$toasted.show('Knowledge Base updated Successfully', self.successToast);
                            self.cancelKBDialog();
                        } else {
                            self.alertDialog = true;
                            self.msg = res.data.message;
                        }
                    })
                    .catch((handle) => {
                        self.alertDialog = true;
                        self.msg = "Please fill all details";
                    })
            } else {
                self.alertDialog = true;
                self.msg = "Please fill valid details";
            }

        },
        deleteKBDialog(data) {
            this.delKBData = data;
            this.delDialog = true;
        },
        deleteKB() {
            let self = this;
            let delData = self.delKBData;
            /* const index = self.KBData.indexOf(delData);
             if (index != -1)
                 self.KBData.splice(index, 1);
             console.log(self.KBData)*/
            axios.delete(self.constant.apiUrl + 'deleteKnowledgeBase/' + delData.id, {headers: self.header})
                .then(function (res) {
                    if (res.data.flag) {
                        self.$toasted.show('Knowledgebase Deleted', self.successToast);
                        self.delDialog = false;
                        const index = self.KBData.indexOf(delData);
                        if (index != -1)
                            self.KBData.splice(index, 1);
                        self.$forceUpdate();
                    }
                    else {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = res.data.message;
                        self.delDialog = false
                    }
                })
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                    self.delDialog = false
                    // self.$toasted.show(handle, self.errorToast);
                });

        },
        searchKB() {
            let self = this;
            let result = self.KBData.filter(function (kb) {
                return (kb.title.toLowerCase().indexOf(self.search.toLowerCase()) >= 0)
            });
            if (result)
                return result
            else
                return 'No Knowledgebase available'
        },
        pickFile() {
            let self = this;
            console.log("self.$refs", self.$refs)
            self.$refs.media.click()
        },
        /*  onFilePicked(e) {
              const files = e.target.files;
              if (files.length == 0)
                  return;
              for (var i = files.length - 1; i >= 0; i--) {
                  this.fileName.push(files[i]);
              }
              // document.getElementById("attachments").value = [];
              console.log("this.fileName", this.fileName)

          },*/
        onFilePicked(e) {
            const files = e.target.files;
            console.log("files", files, files[0])
            if (files[0] !== undefined) {
                this.fileName = files[0].name;
                if (this.fileName.lastIndexOf('.') <= 0) {
                    return
                }
                const fr = new FileReader();
                fr.readAsDataURL(files[0]);
                fr.addEventListener('load', () => {
                    this.file = files[0] // this is an image file that can be sent to server...
                })
            }
            this.uploadBtnFlag = false;
        },

        uploadFile() {
            let self = this;
            let formData = new FormData();
            formData.append('file', this.file);
            self.msg = '';
            axios.post(self.constant.apiUrl + 'uploadAttachment', formData)
                .then(response => {
                    self.fileResponse = {};
                    if (response.data.flag) {
                        self.fileResponse = response.data.data;
                        self.uploadBtnFlag = true;
                        self.$toasted.show("Uploaded Successfully", self.successToast);
                    } else {
                        self.alertDialog = true;
                        self.msg = response.data.message;
                    }

                }).catch((handle) => {
                self.alertDialog = true;
                self.msg = 'Please upload file'
            })
        },
        removeCategoryItem(item) {
            let self = this;
            let index;
            self.kb.categories.forEach(function (val, i) {
                if (val === item.id) {
                    index = i
                }
            });
            if (index !== -1) {
                self.kb.categories.splice(index, 1);
                self.kb.categories = [...self.kb.categories];
            } else
                return false
            /*let self = this;
            const index = self.kb.categories.indexOf(item);
            self.kb.categories.splice(index, 1);
            self.kb.categories = [...self.kb.categories];*/
        },
        Download(url) {
            document.getElementById('downloadFileId').src = url;
        },
        prepareURL(val) {
            var url = val.split('/');
            var apiUrl = 'http://api.connectly.elcarvalli.bizbrain.in/images/uploads/';
            var url5 = url[5].split('-')
            var url5Last = url5[url5.length - 1].split('__')[0]
            var changeW200 = 'w' + url5Last
            var urlData = apiUrl + changeW200 + '/' + url[6];
            console.log("urlData", urlData)
            return urlData;
        }

    }
}



// WEBPACK FOOTER //
// ./src/components/KnowledgeBase/KnowledgeBase.js